module.exports = __webpack_public_path__ + "static/media/28DGC12.4f5bb99f.jpg";